import { Component, OnInit } from '@angular/core';
import { BankingAccountTypeService } from '../banking-account-type.service';
import { BankingAccountType } from '../banking-account-type';
import { Router } from '@angular/router';
import { NotificationService } from '../../../../shared/notification.service';

@Component({
  selector: 'app-banking-account-type-create',
  templateUrl: 'create.component.html',
})
export class BankingAccountTypeCreateComponent implements OnInit {
  /**
   * Details of the accountType being created.
   */
  public accountType: BankingAccountType;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {BankingAccountTypeService} accountTypeService
   * @param {NotificationService} notificationService
   * @param {Router} router
   */
  constructor(
    private accountTypeService: BankingAccountTypeService,
    private notificationService: NotificationService,
    private router: Router,
  ) {
    this.accountTypeService.loading.subscribe(
      result => (this.isLoading = result),
    );
  }

  /**
   * Initialise the component, creating a new blank accountType if required.
   */
  public ngOnInit(): void {
    if (!this.accountType) {
      this.accountType = new BankingAccountType();
    }
  }

  /**
   * Perform the create action which adds the new accountType into the backend.
   */
  public create() {
    const createBankingAccountType = this.accountTypeService
      .createBankingAccountType(this.accountType)
      .subscribe(
        (result: BankingAccountType) => {
          this.notificationService.success(
            `BankingAccountType Created`,
            `New accountType ${result.name} has been created with ID of ${
              result.id
            }.`,
            5,
          );
          this.accountType = new BankingAccountType();
          createBankingAccountType.unsubscribe();
          this.router.navigate(['/banking/account-types']);
        },
        err => {
          this.notificationService.error(
            `Could not create BankingAccountType`,
            err.error.message,
            10,
          );
        },
      );
  }
}
